/**
 * Customer-facing membership product labels.
 * Strips duration prefixes and common lock-in / billing suffixes from catalog names.
 *
 * @param {string} rawName
 * @param {{ lockInPeriodMonths?: number|string|null }} [options]
 */
export function formatMembershipProductDisplayName(rawName, options = {}) {
  if (rawName == null || typeof rawName !== "string") return "";
  let s = rawName.trim();
  if (!s) return s;

  s = s.replace(/^subscribe\s+to\s+/i, "").trim();

  const lockIn =
    options.lockInPeriodMonths != null
      ? Number(options.lockInPeriodMonths)
      : null;
  const stripDurationPrefix =
    lockIn == null || !Number.isFinite(lockIn) || lockIn < 12;

  let rest = s;
  if (stripDurationPrefix) {
    const intervalPrefix =
      /^\d+\s*(?:-\s*)?(?:year|years|month|months|week|weeks|day|days)\b\s*/i;
    let prev;
    do {
      prev = rest;
      rest = prev.replace(intervalPrefix, "").trim();
    } while (rest !== prev);
  }

  rest = rest
    .replace(/\s*\(\s*monthly\s*\)\s*$/i, "")
    .replace(/\s*\(\s*12-Month Lock-In\s*\)\s*$/i, "")
    .replace(/\s*\(\s*12\s*month\s*lock-?in\s*\)\s*$/i, "")
    .replace(/\s*\(\s*6-Month Lock-In\s*\)\s*$/i, "")
    .replace(/\s*\(\s*6\s*month\s*lock-?in\s*\)\s*$/i, "")
    .trim();

  return rest || s;
}

/** Per-signup lock-in under 12 months → monthly billing label. */
export function resolveSignupBillingLabel(productInterval, lockInPeriodMonths) {
  const lockIn =
    lockInPeriodMonths != null ? Number(lockInPeriodMonths) : null;
  if (lockIn != null && Number.isFinite(lockIn) && lockIn < 12) {
    return "monthly";
  }
  if (productInterval === "month") return "monthly";
  if (productInterval === "year") return "yearly";
  return productInterval || null;
}
